export interface IDriver {
  _id: String
  company: String | Object
  fullName: String
  idCardNumber: String
  phone: any
  email: String
  vehicle: String | Object
  status?: number | null
  code: String
}

const rulesDriver = {
  fullName: 'required',
  idCardNumber: 'required',
  phone: 'required',
  email: 'email'
}

const rulesHeathCheck = {
  'driverModule.healthCheck.value': 'required',
  description: 'required',
  'driverModule.healthCheck.date': 'required|biggerDate'
}

const rulesDocument = {
  document: 'required|fileSize:10',
  documentType: 'required',
  expiredDate: 'invalidDateFormat'
}

const rulesEditDocument = {
  documentType: 'required',
  document: 'fileSize:10',
  expiredDate: 'invalidDateFormat'
}

const initDriver = {
  fullName: null,
  idCardNumber: null,
  phone: {
    countryCode: '',
    phone: '',
    code: ''
  },
  email: null,
  vehicle: null,
  cooperator: '',
  companyUserId: '',
  companyUserName: ''
}

const initHealthCheck = {
  driver: null,
  value: null,
  description: null,
  date: null
}

const rulesLicense = {
  'driverModule.license.no': 'required',
  'driverModule.license.class': 'required',
  'driverModule.license.expires': 'required|invalidDateFormat',
  'driverModule.license.front': 'required|fileSize:10',
  'driverModule.license.back': 'required|fileSize:10'
}

const rulesEditLicense = {
  'driverModule.license.no': 'required',
  'driverModule.license.class': 'required',
  'driverModule.license.expires': 'invalidDateFormat',
  'driverModule.license.front': 'fileSize:10',
  'driverModule.license.back': 'fileSize:10'
}

export default {
  rulesDriver,
  initDriver,
  rulesHeathCheck,
  initHealthCheck,
  rulesDocument,
  rulesEditDocument,
  rulesLicense,
  rulesEditLicense
}
